module.exports = __webpack_public_path__ + "media/images/card-logos-b8344e322d027d350f8eaf51d539a3c9.png";